import { render } from "./musicHome.vue?vue&type=template&id=49f6a6e8&scoped=true"
import script from "./musicHome.vue?vue&type=script&lang=js"
export * from "./musicHome.vue?vue&type=script&lang=js"

import "./musicHome.vue?vue&type=style&index=0&id=49f6a6e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49f6a6e8"

export default script